<template>
  <v-app class="white">
    <div class="py-5 secondary">
        <toolbar />
    </div>

    <v-main>
      <v-container
        v-if="$vuetify.breakpoint.lgAndUp"
        fluid
        class="secondary fill-height pt-5 pa-0"
      >
        <v-row class="fill-height">
          <v-col
            ref="sidebarWrapper"
            cols="3"
            class="left-content"
          >
            <v-row>
              <v-col
                ref="sidebarContent"
                class="sidebar-content"
                :class="sidebarClasses"
              >
                <navigation />
              </v-col>
            </v-row>
          </v-col>
          <v-col
            cols="9"
            class="right-content elevation-1"
          >
            <v-fade-transition mode="out-in">
              <router-view />
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-else>
        <mobile-navigation />
        <v-row>
          <v-col>
            <v-fade-transition mode="out-in">
              <router-view />
            </v-fade-transition>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <messager />
  </v-app>
</template>

<script>
  import Toolbar from './components/Toolbar'
  import Navigation from './components/Navigation'
  import MobileNavigation from './components/MobileNavigation'
  import Messager from './components/Messager'

  export default {
    components: {
      'toolbar': Toolbar,
      'navigation': Navigation,
      'mobile-navigation': MobileNavigation,
      'messager': Messager
    },
    data: () => ({
      sidebar: {
        height: 0,
        windowHeight: 0,
        windowScrollTop: 0,
        wrapperOffset: 0,
        heightWithOffset: 0
      }
    }),
    computed: {
      sidebarClasses () {
        if (this.sidebar.windowScrollTop > this.sidebar.wrapperOffset) {
          if (this.sidebar.height <= this.sidebar.windowHeight) {
            return { 'col-3 fixed fixed-top': true }
          } else if ((this.sidebar.windowScrollTop + this.sidebar.windowHeight) > this.sidebar.heightWithOffset) {
            return { 'col-3 fixed fixed-bottom': true }
          } else {
            return { }
          }
        } else {
          return { }
        }
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      window.addEventListener('scroll', this.handleScroll)
    },
    mounted () {
      this.$nextTick(() => {
        this.calculateSidebar()
      })
    },
    methods: {
      calculateSidebar () {
        this.sidebar.height = this.$refs.sidebarContent.offsetHeight
        this.sidebar.windowHeight = window.innerHeight
        this.sidebar.wrapperOffset = this.$refs.sidebarWrapper.offsetTop + (this.$refs.sidebarWrapper.offsetParent ? this.$refs.sidebarWrapper.offsetParent.offsetTop : 0)
        this.sidebar.heightWithOffset = this.sidebar.height + this.sidebar.wrapperOffset
      },
      handleResize () {
        this.calculateSidebar()
      },
      handleScroll () {
        this.sidebar.windowScrollTop = window.pageYOffset || document.documentElement.scrollTop
      }
    }
  }
</script>

<style>
    .right-content {
        background: #fff;
        border-radius: 1rem 0 0 0;
    }
</style>
